import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import React, { useEffect, useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
import { GlobalHelper } from "../../indexImports"
import Integrations from "../../integration/Integrations"
import { isError } from "../../state/helpers/Error"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import { InvoiceImportableDto } from "../../state/integration/InvoiceImportable"
import IntegrationImportableService from "../../state/integration/InvoiceImportableService"
import Invoice from "../../state/invoice/models/invoice"

const validationNeeded = [INTEGRATION_KEY.LIGHTSPEED_RETAIL]

type Props = {
    invoice: Invoice
    onHide: () => boolean
    onDelete: () => object
}


const DeleteInvoiceModal = (props: Props) => {
    const requiresValidation = () => {
        return !!GlobalHelper.hasIntegrations(validationNeeded)
    }

    const [isDisabled, setIsDisabled] = useState(requiresValidation())
    const [importablesToVoid, setImportablesToVoid] = useState<InvoiceImportableDto[]>([])


    useEffect(() => {
        if (requiresValidation()) {
            IntegrationImportableService.getUnVoidedExternalInvoices(props.invoice.getAllExternalLinks()).then(res => {
                if (!isError(res)) {
                    const importableDtos = res as InvoiceImportableDto[]
                    setImportablesToVoid(importableDtos)
                    if (importableDtos.length == 0) {
                        setIsDisabled(false)
                    }
                }
            })
        }
    }, [])

    const onDelete = () => {
        return props.onDelete()
    }

    return (
        <Modal
            {...props}
            centered>
            <Modal.Body>
                <FormattedMessage
                    id="invoice.analytics.delete_message"
                    defaultMessage="Are you sure you want to delete invoice {identifier} ?"
                    values={{
                        identifier: props.invoice.getIdentifier()
                    }}
                />

                {props.invoice.getAllExternalLinks().length > 0 && GlobalHelper.hasQuickBooksIntegration() &&
                    <em>
                        <br/>
                        <br/>
                        <FormattedMessage
                            id="invoice.analytics.delete_message.integration_warning_quickbooks"
                            defaultMessage="This received payment exported to QuickBooks.
                            If you wish to delete it, you also need to void these sales as well: "
                        />
                        {props.invoice.getPaymentTransactions().filter(pay =>
                            pay.getExternalLinks().length !== 0).map(pay => {
                            return pay.getExternalLinks().filter(l =>
                                l.attributes.integrationKey !== "stripe").map(link => {
                                const url = Integrations.getPaymentTransactionExternalUrl(link)
                                return <span key={link.id}>
                                    <br/>
                                    <a href={url} target="_blank" rel="noreferrer">
                                            #{link.attributes.externalId}
                                    </a>
                                </span>
                            })
                        })}
                    </em>
                }

                {importablesToVoid.length > 0 &&
                        <div className="mt-4">
                            <FormattedMessage
                                id="invoice.analytics.delete_message.integration_warning_message"
                                defaultMessage="If you wish to continue, you must first void these sales: "
                            />
                            {importablesToVoid.map((link, i) => {
                                const url = Integrations.getExternalSaleUrl(link)
                                return  (
                                    <div key={i}>
                                        <a href={url} target="_blank" rel="noreferrer">
                                            #{link.saleId}
                                        </a>
                                    </div>
                                )
                            })
                            }
                        </div>
                }
            </Modal.Body>

            <Modal.Footer>
                <Button
                    onClick={props.onHide}
                    variant="secondary">
                    Close
                </Button>
                
                <Button
                    onClick={onDelete}
                    variant="primary"
                    disabled={isDisabled && !AppContext.getUserLoggedIn().attributes.superUser}>
                    <FormattedMessage
                        id="common.confirm.modal.yes_btn"
                        defaultMessage="Yes"
                    />
                </Button>
            </Modal.Footer>
        </Modal>
    )
}


export default injectIntl(DeleteInvoiceModal)



// WEBPACK FOOTER //
// ./src/invoice/components/DeleteInvoiceModal.tsx